export default "__VITE_PUBLIC_ASSET__9fa25d9f__"